export const SECTIONS = {
  clientDetails: "Client Details",
  licensedFamilies: "Related Parties",
  statusByFamily: "Status By Family",
  paralegalInstructions: "Instructions for Paralegals",
  ppsInstructions: "Instructions for PPS",
  recurringActions: "Recurring Actions",
  foreignAssociates: "Foreign Associates",
  inventors: "Inventors",
  clientPreferences: "Client Preferences",
  attorneyPreferences: "Attorney Preferences",
  annuties: "Annuties",
  additionalInfo: "Additional Information",
};

export const CLICKABLE_ACTIONS = new Set(["CREATE"]);

export const FIELDS = {
  familyNos: "Family No(s)",
  row: "Row",
  country: "Country",
  status: "Status",
  wsgrHandles: "WSGR Handles",
  legalName: "Legal Name",
};

export const US_STATES = ["Alabama", "Alaska", "Arizona", "Arkansas", "California", "Colorado", "Connecticut", "Delaware", "Florida", "Georgia", "Hawaii", "Idaho", "Illinois", "Indiana", "Iowa", "Kansas", "Kentucky", "Louisiana", "Maine", "Maryland", "Massachusetts", "Michigan", "Minnesota", "Mississippi", "Missouri", "Montana", "Nebraska", "Nevada", "New Hampshire", "New Jersey", "New Mexico", "New York", "North Carolina", "North Dakota", "Ohio", "Oklahoma", "Oregon", "Pennsylvania", "Rhode Island", "South Carolina", "South Dakota", "Tennessee", "Texas", "Utah", "Vermont", "Virginia", "Washington", "West Virginia", "Wisconsin", "Wyoming"];

export const COUNTRIES = {
  "United States of America": "US",
  Albania: "AL",
  Algeria: "DZ",
  Andorra: "AD",
  Angola: "AO",
  Anguilla: "AI",
  Antarctica: "AQ",
  "Antigua and Barbuda": "AG",
  Argentina: "AR",
  Armenia: "AM",
  Aruba: "AW",
  Australia: "AU",
  Austria: "AT",
  Azerbaijan: "AZ",
  Bahamas: "BS",
  Bahrain: "BH",
  Bangladesh: "BD",
  Barbados: "BB",
  Belarus: "BY",
  Belgium: "BE",
  Belize: "BZ",
  Bermuda: "BM",
  Bhutan: "BT",
  Bolivia: "BO",
  Bophuthatswana: "BP",
  "Bosnia and Herzegovina": "BA",
  Botswana: "BW",
  Brazil: "BR",
  "Brunei Darussalam": "BN",
  Bulgaria: "BG",
  Burundi: "BI",
  Cambodia: "KH",
  "Cabo Verde": "CV",
  Cameroon: "CM",
  Canada: "CA",
  "Cape Verde": "CV",
  "Cayman Islands": "KY",
  Chile: "CL",
  China: "CN",
  "Colon Free Zone": "CZ",
  "Costa Rica": "CR",
  Colombia: "CO",
  Croatia: "HR",
  Cuba: "CU",
  Cyprus: "CY",
  Czechia: "CZ",
  "Democratic People’s Republic of Korea": "KP",
  "Democratic Republic of the Congo": "CD",
  Denmark: "DK",
  Djibouti: "DJ",
  Dominica: "DM",
  "Dominican Republic": "DO",
  Ecuador: "EC",
  Egypt: "EG",
  "El Salvador": "SV",
  Estonia: "EE",
  Eswatini: "SZ",
  Ethiopia: "ET",
  "Falkland Islands (Malvinas)": "FK",
  "Faroe Islands": "FO",
  Fiji: "FJ",
  Finland: "FI",
  France: "FR",
  "French Ploynesia": "FP",
  Gambia: "GM",
  "Gaza Strip": "GS",
  Georgia: "GE",
  Germany: "DE",
  Ghana: "GH",
  Gibraltar: "GI",
  Greece: "GR",
  Greenland: "GL",
  Grenada: "GD",
  Guatemala: "GT",
  Guernsey: "GG",
  Guyana: "GY",
  Haiti: "HT",
  Honduras: "HN",
  "Hong Kong Special Admin. Region of the PRC": "HK",
  Hungary: "HU",
  Iceland: "IS",
  India: "IN",
  Indonesia: "ID",
  "Iran (Islamic Republic of)": "IR",
  Iraq: "IQ",
  Ireland: "IE",
  "Isle of Man": "IM",
  Israel: "IL",
  Italy: "IT",
  Jamaica: "JM",
  Japan: "JP",
  Jersey: "JE",
  Jordan: "JO",
  Kazakhstan: "KZ",
  Kenya: "KE",
  "The Republic of Kiribati": "KI",
  Kosovo: "KV",
  Kuwait: "KW",
  Kyrgyzstan: "KG",
  Laos: "LA",
  Latvia: "LV",
  Lebanon: "LB",
  Lesotho: "LS",
  Liberia: "LR",
  Libya: "LY",
  Liechtenstein: "LI",
  Lithuania: "LT",
  Luxembourg: "LU",
  Macao: "MO",
  Madagascar: "MG",
  Malawi: "MW",
  Malaysia: "MY",
  Maldives: "MV",
  Mali: "ML",
  Malta: "MT",
  Mauritius: "MU",
  Mexico: "MX",
  Monaco: "MC",
  Mongolia: "MN",
  Montenegro: "ME",
  Montserrat: "MS",
  Morocco: "MA",
  Mozambique: "MZ",
  Myanmar: "MM",
  Namibia: "NA",
  Nauru: "NR",
  Nepal: "NP",
  Netherlands: "NL",
  "New Zealand": "NZ",
  Nicaragua: "NI",
  Niger: "NE",
  Nigeria: "NG",
  "North Macedonia": "MK",
  "Northen Cyprus": "CY",
  Norway: "NO",
  Oman: "OM",
  Pakistan: "PK",
  Palau: "PW",
  Panama: "PA",
  "Papua New Guinea": "PG",
  Paraguay: "PY",
  PCT: "PC",
  Peru: "PE",
  Philippines: "PH",
  Poland: "PL",
  Portugal: "PT",
  "Puerto Rico": "PR",
  Qatar: "QA",
  "Republic of Moldova": "MD",
  Romania: "RO",
  "Russian Federation": "RU",
  Rwanda: "RW",
  Sabah: "SH",
  "Saint Helena, Ascension and Tristan da Cunha": "SH",
  "Saint Kitts and Nevis": "KN",
  "Saint Lucia": "LC",
  "Saint Vincent and the Grenadines": "VC",
  Samoa: "WS",
  "San Marino": "SM",
  "Sao Tome and Principe": "ST",
  Sarawak: "SW",
  "Saudi Arabia": "SA",
  Senegal: "SN",
  Serbia: "RS",
  Seychelles: "SC",
  "Sierra Leone": "SL",
  Singapore: "SG",
  "Sint Maarten (Dutch part)": "SX",
  Slovakia: "SK",
  Slovenia: "SI",
  "Solomon Islands": "SB",
  Somalia: "SO",
  "South Africa": "ZA",
  "South Korea": "KR",
  "South Georgia and the South Sandwich Islands": "GS",
  Spain: "ES",
  "Sri Lanka": "LK",
  Sudan: "SD",
  Suriname: "SR",
  Swaziland: "SZ",
  Sweden: "SE",
  Switzerland: "CH",
  "Syrian Arab Republic": "SY",
  Taiwan: "TW",
  Tajikistan: "TJ",
  Tanganyika: "TK",
  Tangiers: "TR",
  Thailand: "TH",
  "Timor–Leste": "TL",
  Togo: "TG",
  Tonga: "TO",
  Transkei: "TI",
  Transnistria: "TA",
  "Trinidad and Tobago": "TT",
  Tunisia: "TN",
  Turkey: "TR",
  Turkmenistan: "TM",
  "Turks and Caicos Islands": "TC",
  Tuvalu: "TV",
  Uganda: "UG",
  Ukraine: "UA",
  "United Arab Emirates": "AE",
  "United Kingdom": "GB",
  "United Republic of Tanzania": "TZ",
  Uruguay: "UY",
  Uzbekistan: "UZ",
  Vanuatu: "VU",
  Venezuela: "VE",
  Vietnam: "VN",
  "Virgin Islands (British)": "VG",
  "Virgin Islands (US)": "VI",
  "West Bank": "WB",
  Yemen: "YE",
  Zambia: "ZM",
  Zanzib: "ZZ",
  Zimbabwe: "ZW",
};

export const SECTION_MAPPING = {
  ClientDetail: "Client Detail",
  BillingInvoice: "Billing Invoice",
  ClientPreference: "Client Preference",
  AdditionalInformation: "Additional Information",
  Correspondence: "Correspondence",
  Personnel: "Personnel",
  LicensedFamily: "LicensedFamily",
  ShadowingStatusFamily: "ShadowingStatusFamily",
  ParalegalInstruction: "ParalegalInstruction",
  PpsInstruction: "PpsInstruction",
  RecurringAction: "RecurringAction",
  ForeignAssociate: "ForeignAssociate",
  Inventor: "Inventor",
  AgentAttorneyPreference: "AgentAttorneyPreference",
  Annuity: "Annuity",
};

export const SECTION_SCHEMA_MAPPING = {
  clientDetails: "ClientDetail",
  licensedFamilies: "LicensedFamily",
  statusByFamily: "ShadowingStatusFamily",
  paralegalInstructions: "ParalegalInstruction",
  ppsInstructions: "PpsInstruction",
  recurringActions: "RecurringAction",
  foreignAssociates: "ForeignAssociate",
  inventors: "Inventor",
  billingIdsArrangement: "BillingInvoicing",
  billingInstructions: "BillingInstruction",
  billingInvoicingRecipients: "BillingInvoicingRecipient",
  clientPreferences: "ClientPreference",
  attorneyPreferences: "AgentAttorneyPreference",
  annuties: "Annuity",
  additionalInfo: "AdditionalInformation",
  correspondence: "Correspondence",
};
